export var rowTypeAttr = 'k-parent-node';
export var colgroupAttr = 'k-colgroup-data';
export var resizableAttr = 'k-resizable-node';
export var resizableWrap = 'k-editor-resize-wrap-element';
export var resizeHandle = 'k-editor-resize-handle';
export var dataResizeDirTable = 'data-dir-table-resize';
export var dataResizeDirImage = 'data-dir-image-resize';
